// extracted by mini-css-extract-plugin
module.exports = {"markdown":"style_markdown__1C5Mh","secondaryText":"style_secondaryText__2ZrrC"};